import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Login from './pages/Login.js';
import Register from './pages/Register.js';
import MobileReport from './pages/MobileReport.js';
import HomeAdmin from './pages/HomeAdmin.js';
import HomeTresRios from './pages/HomeTresRios.js';
import HomePaulo from './pages/HomePaulo.js';
import HomeSaquarema from './pages/HomeSaquarema.js';
import HomeRio from './pages/HomeRio.js';
import HomeNovaIguacu from './pages/HomeNovaIguacu.js';
import HomeCabo from './pages/HomeCabo.js';
import HomeQueimados from './pages/HomeQueimados.js';
import HomeItaocara from './pages/HomeItaocara.js';
import HomeCampos from './pages/HomeCampos.js';
import CitzenHome from './pages/CitzenHome.js';
import Details from './pages/Details.js';
import Subcategories from './pages/Subcategories.js';
import Process from './pages/Process.js';
import Search from './pages/Search.js';

import ProcessRegister from './pages/ProcessRegister.js';

function AppRoutes() {
  return (
    <Routes>
      <Route path='/' element={<Login />} />
      <Route path='/register' element={<Register />} />
      <Route path='/report' element={<MobileReport />} />
      <Route path='/homeadmin' element={<HomeAdmin />} />
      <Route path='/hometresrios' element={<HomeTresRios />} />
      <Route path='/homepaulo' element={<HomePaulo />} />
      <Route path='/homecabo' element={<HomeCabo />} />
      <Route path='/homesaquarema' element={<HomeSaquarema />} />
      <Route path='/homenova' element={<HomeNovaIguacu />} />
      <Route path='/homequeimados' element={<HomeQueimados />} />
      <Route path='/homeitaocara' element={<HomeItaocara />} />
      <Route path='/homecampos' element={<HomeCampos />} />
      <Route path='/homerj' element={<HomeRio />} />
      <Route path='/citzenhome' element={<CitzenHome />} />
      <Route path='/details' element={<Details />} />
      <Route path='/subcategories' element={<Subcategories />} />
      <Route path='/process' element={<Process />} />
      <Route path='/search' element={<Search />} />
      <Route path='/processregister' element={<ProcessRegister />} />
    </Routes>
  );
}

export default AppRoutes;